/**
 * Support Service
 * 
 * Phase 2-B: Session Cookie Authentication
 * - Custom axios instances now use withCredentials: true
 * - access-token header REMOVED - auth is via session cookie
 */

import axios from "axios";
import API from "../../api/api";
import { BASE_URL, DEFAULT_KEY } from "../../config/config";

const callApi = async (endpoint) => {
    try {
        const response = await API.get(endpoint);
        if (response.status === 200) {
            return response?.data?.data;
        } else {
            return response?.data?.data;
        }
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const SupportServices = {
    getTickets: async (page, itemsPerPage, category, priority, ticketId, status, sortBy, sortOrder) => {
        const response = await callApi(`/tickets?trackId=${ticketId}&category=${category}&priority=${priority}&status=${status}&page=${page}&perPage=${itemsPerPage}&sortBy=${sortBy || 'createdAt'}&sortOrder=${sortOrder || 'desc'}`);
        return response
    },
    getTicketPartials: async () => {
        const response = await callApi(`/ticket-partials`);
        return response
    },
    getTrackId: async () => {
        const response = await callApi('ticket-trackId');
        return response
    },
    createTicket: async (data) => {
        const formData = new FormData();

        [...data.attachment].forEach((file, i) => {
            formData.append(`file`, file);
        });
        formData.append('categoryId', data.category)
        formData.append('subject', data.subject)
        formData.append('trackId', data.ticketId)
        formData.append('message', data.message)

        // Create a new Axios instance for FormData upload
        const customAxios = axios.create({
            baseURL: BASE_URL,
            withCredentials: true, // Required for session cookies
        });

        customAxios.defaults.headers.common["api-key"] =
            localStorage.getItem("api-key") || DEFAULT_KEY;
        // NOTE: access-token header REMOVED - auth is via session cookie
        customAxios.defaults.headers.common["Content-Type"] = "multipart/form-data";

        try {
            const response = await customAxios.post(`ticket`, formData);
            return response.data;
        } catch (error) {
            return error?.response?.data;
        }
    },
    getTicketDetails: async (trackId) => {
        const response = await callApi(`ticket-details/${trackId}`)
        return response
    },
    getTicketReplies: async (trackId) => {
        const response = await callApi(`ticket-replies/${trackId}`)
        return response
    },
    ticketReply: async (data) => {
        const formData = new FormData();

        [...data.files].forEach((file, i) => {
            formData.append(`file`, file);
        });
        formData.append('msg', data.message)

        // Create a new Axios instance for FormData upload
        const customAxios = axios.create({
            baseURL: BASE_URL,
            withCredentials: true, // Required for session cookies
        });

        customAxios.defaults.headers.common["api-key"] =
            localStorage.getItem("api-key") || DEFAULT_KEY;
        // NOTE: access-token header REMOVED - auth is via session cookie
        customAxios.defaults.headers.common["Content-Type"] = "multipart/form-data";

        try {
            const response = await customAxios.put(`ticket-chat/${data.trackId}`, formData);
            return response.data;
        } catch (error) {
            return error?.response?.data;
        }
    },
    getTicketFaqs: async () => {
        const response = await callApi("ticket-faq");
        return response
    },
    ticketTimeline: async (trackId) => {
        const response = await callApi(`ticket-timeline/${trackId}`);
        return response
    },
    reopenTicket: async (trackId) => {
        const customAxios = axios.create({
            baseURL: BASE_URL,
            withCredentials: true,
        });

        customAxios.defaults.headers.common["api-key"] =
            localStorage.getItem("api-key") || DEFAULT_KEY;

        try {
            const response = await customAxios.put(`ticket-reopen/${trackId}`);
            return response.data;
        } catch (error) {
            return error?.response?.data;
        }
    }
}
